import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	starredColumnHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	starBoard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unstarBoard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameColumnHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adminColumnHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	locationColumnHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionsColumnHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	starredColumnHeader: {
		id: 'home.tabs.boards.boards-table.starred-column-header',
		defaultMessage: 'Starred',
		description: 'Column header for the starred column in the boards table.',
	},
	starBoard: {
		id: 'home.tabs.boards.boards-table.star-board',
		defaultMessage: 'Add to starred',
		description: "Label for the button that adds the board to the user's starred items",
	},
	unstarBoard: {
		id: 'home.tabs.boards.boards-table.unstar-board',
		defaultMessage: 'Remove from starred',
		description: "Label for the button that removes the board from the user's starred items",
	},
	nameColumnHeader: {
		id: 'home.tabs.boards.boards-table.name-column-header',
		defaultMessage: 'Name',
		description: 'Column header for the name column in the boards table.',
	},
	adminColumnHeader: {
		id: 'home.tabs.boards.boards-table.admin-column-header',
		defaultMessage: 'Admin',
		description: 'Column header for the admin column in the boards table.',
	},
	locationColumnHeader: {
		id: 'home.tabs.boards.boards-table.location-column-header',
		defaultMessage: 'Location',
		description: 'Column header for the location column in the boards table.',
	},
	actionsColumnHeader: {
		id: 'home.tabs.boards.boards-table.actions-column-header',
		defaultMessage: 'Actions',
		description: 'Column header for the actions column in the boards table.',
	},
});
export default messages;
